import React from 'react';
import { PokemonCard } from '../../types/pokemon';
import { AddableCardItem } from './AddableCardItem';
import { Loader2 } from 'lucide-react';

interface AddableCardGridProps {
  cards: PokemonCard[];
  loading: boolean;
  selectedCards: Map<number, number>;
  onUpdateQuantity: (cardId: number, quantity: number) => void;
  maxQuantityPerCard?: number;
  totalSelectedCards: number;
}

export function AddableCardGrid({
  cards,
  loading,
  selectedCards,
  onUpdateQuantity,
  maxQuantityPerCard = 2,
  totalSelectedCards
}: AddableCardGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="bg-gray-100 rounded-xl aspect-[3/4] animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
      {cards.map((card) => (
        <AddableCardItem
          key={card.id}
          card={card}
          quantity={selectedCards.get(card.id) || 0}
          onUpdateQuantity={(quantity) => {
            onUpdateQuantity(card.id, quantity);
          }}
          maxQuantity={maxQuantityPerCard}
          disabled={totalSelectedCards >= 20 && !selectedCards.has(card.id)}
        />
      ))}
    </div>
  );
}